var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDesktop = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    d: "M17.122 3H2.979C2.328 3 1.8 3.528 1.8 4.179v9.428c0 .651.528 1.179 1.179 1.179h14.143c.65 0 1.178-.528 1.178-1.179V4.18C18.3 3.528 17.772 3 17.122 3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m11.818 17.143-.295-2.358H8.577l-.295 2.357z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M14.175 17.142h-8.25"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.8 11.839v1.768a1.18 1.18 0 0 0 1.179 1.178h14.143a1.18 1.18 0 0 0 1.178-1.178v-1.768zm8.25 2.357a.59.59 0 1 1 0-1.18.59.59 0 0 1 0 1.18"
  })));
};
export { SvgDesktop as ReactComponent };